import List from "@/components/list";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  const AccountTableConfig = [
    {
      label: "资源分类",
      prop: "categoryName",
      minWidth: "150"
    },
    {
      label: "学时要求",
      prop: "examCredit",
      minWidth: "150"
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
